import { Link, useNavigate } from 'react-router-dom';
import { useStore } from '../lib/useStore.jsx';
import { appOf } from '../lib/store.js';
import { ownedCount } from '../domain/skills.js';
import { SKILLS } from '../content/skills.js';
import { Avatar } from '../ui/Bits.jsx';

export default function Who() {
  const { store, setActive } = useStore();
  const nav = useNavigate();
  return (
    <div className="stack">
      <h1>Who's this?</h1>
      {store.profiles.map((p) => {
        const n = ownedCount(SKILLS, appOf(p).events);
        return (
          <button key={p.id} className={`profile-row ${p.id === store.activeId ? 'active' : ''}`} onClick={() => { setActive(p.id); nav('/'); }}>
            <Avatar profile={p} />
            <div><div style={{ fontWeight: 800 }}>{p.name}</div><div className="small muted">{n} thing{n === 1 ? '' : 's'} they can do</div></div>
          </button>
        );
      })}
      <Link to="/setup" className="btn">Add someone</Link>
    </div>
  );
}
